module.exports = __webpack_public_path__ + "static/media/gryphon_x_ids_prototypeexhibition_logo.adc24c37.svg";